import uniqueId from 'lodash/uniqueId';

export function removePort(portList, item) {
    const portListValue = Object.values(Object.assign({}, portList));
    const removeIndex = portListValue.map(port => {
        return port.id;
    }).indexOf(item.id);
    portListValue.splice(removeIndex, 1);
    return portListValue;
}

export function addPort(state, clickedNodeID, nodeName, buttonNumber) {

    const portList = Object.values(Object.assign({}, state.portList));
    switch (nodeName) {
        case 'switch':
            portList.push({
                parentID: clickedNodeID,
                id: uniqueId(),
                nodeName: 'Empty Input',
                branchName: '',
                index: portList.length,
                edit: false,
                sectionType: 'empty',
                logDecisionValue: '',
                predicate: {
                    ...state.predicate
                },
                in: true
            });
            break;
        case 'modifier':
            portList.push({
                parentID: clickedNodeID,
                id: uniqueId(),
                nodeName: 'Empty Modifier',
                branchName: '',
                index: portList.length,
                edit: false,
                sectionType: 'empty',
                logDecisionValue: '',
                predicate: {
                    ...state.predicate
                },
                modifier: {
                    ...state.modifier
                },
                overwriteDynamicProperty: state.overwriteDynamicProperty,
                compositeFieldName: state.compositeFieldName,
                in: true
            });
            break;
        case 'combinator':
            portList.push({
                parentID: clickedNodeID,
                id: uniqueId(),
                nodeName: 'Empty Input',
                index: portList.length,
                variableName: `V${buttonNumber}`,
                in: true
            });
            break;
        default:
            portList.push({
                parentID: clickedNodeID,
                id: uniqueId(),
                nodeName: 'Empty Input',
                branchName: '',
                groupID: uniqueId(),
                index: portList.length,
                roundRobin: false,
                edit: false,
                sectionType: 'empty',
                groupData: {
                    groupID: uniqueId(),
                    rounds: 1,
                    randomizeAllRounds: false,
                    randomizeInsideRound: false
                },
                exclude: false,
                itemCount: null,
                logDecisionValue: '',
                randomize: false,
                useUnder: null,
                in: true
            });
    }


    const newPortList = [];
    const inputPortList = portList.filter(port => port.in);
    const outputPortList = portList.filter(port => port.in === false);
    inputPortList.forEach((v, i) => {
        v.index = i;
        newPortList.push(v);
    });
    outputPortList.forEach((v) => {
        newPortList.push(v);
    });
    return newPortList;
}

export function editButton(portListData, item) {
    const portList = Object.assign({}, portListData);
    return Object.values(portList).map((v) => {
        if (v.id === item.id)
            v.edit = !v.edit;
        return v;
    });
}
